import JsBarcode from "jsbarcode";

export const printBarcode = (barcode: string, label?: string) => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  JsBarcode(svg, barcode, { format: "CODE128", width: 2, height: 45, fontSize: 14, margin: 0 });

  const printWindow = window.open("", "_blank", "width=400,height=300");
  if (!printWindow) return;

  printWindow.document.write(`
    <html>
      <head>
        <style>
          @page { size: 50mm 25mm; margin: 0; }
          body { margin: 0; display: flex; flex-direction: column; align-items: center; justify-content: center;
                 height: 25mm; font-family: Arial, sans-serif; }
          p { margin: 0 0 1mm; font-size: 6pt; }
          svg { max-width: 48mm; }
        </style>
      </head>
      <body>
      ${label ? `<p>${label}</p>` : ""}
        ${svg.outerHTML}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  printWindow.onafterprint = () => printWindow.close();
  printWindow.print();
};
